var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"chevron-down",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 7.5L10 12.5L15 7.5","stroke":"#ffffff","stroke-width":"1.66667","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }